import { LISTING_TYPE_PLURAL_HUMAN_NAME_MAP_TITLE } from 'utils/constants/general/listingTypePluralHumanNameMapTitle';

export const AMP_PAGE_HEADER_NAV = [
  'JOB',
  'INTERNSHIP',
  'VOLOP',
  'ORG',
  'EVENT',
] as const;

export const AMP_PAGE_HEADER_NAV_MAP: Record<
  (typeof AMP_PAGE_HEADER_NAV)[number],
  string
> = {
  JOB: LISTING_TYPE_PLURAL_HUMAN_NAME_MAP_TITLE.JOB,
  INTERNSHIP: LISTING_TYPE_PLURAL_HUMAN_NAME_MAP_TITLE.INTERNSHIP,
  VOLOP: LISTING_TYPE_PLURAL_HUMAN_NAME_MAP_TITLE.VOLOP,
  ORG: LISTING_TYPE_PLURAL_HUMAN_NAME_MAP_TITLE.ORG,
  EVENT: LISTING_TYPE_PLURAL_HUMAN_NAME_MAP_TITLE.EVENT,
};
